export default "__VITE_ASSET__2ac1ad0f__"